<div class="menu-items">
    <a [routerLink]="menuItem.route" class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngFor="let menuItem of menuItems">
        <span class="selected-indicator"></span>
        <span class="icon" [ngStyle]="{'background-image':'url(' + menuItem.icon + ')'}"></span>
        <span class="text">{{ menuItem.name }}</span>
    </a>
</div>
